/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkPatternOverride } from './WorkPatternOverride';
import {
    WorkPatternOverrideFromJSON,
    WorkPatternOverrideFromJSONTyped,
    WorkPatternOverrideToJSON,
    WorkPatternOverrideToJSONTyped,
} from './WorkPatternOverride';

/**
 * 
 * @export
 * @interface CreateWorkPatternOverrideResponse
 */
export interface CreateWorkPatternOverrideResponse {
    /**
     * 
     * @type {WorkPatternOverride}
     * @memberof CreateWorkPatternOverrideResponse
     */
    data: WorkPatternOverride;
}

/**
 * Check if a given object implements the CreateWorkPatternOverrideResponse interface.
 */
export function instanceOfCreateWorkPatternOverrideResponse(value: object): value is CreateWorkPatternOverrideResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateWorkPatternOverrideResponseFromJSON(json: any): CreateWorkPatternOverrideResponse {
    return CreateWorkPatternOverrideResponseFromJSONTyped(json, false);
}

export function CreateWorkPatternOverrideResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkPatternOverrideResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': WorkPatternOverrideFromJSON(json['data']),
    };
}

  export function CreateWorkPatternOverrideResponseToJSON(json: any): CreateWorkPatternOverrideResponse {
      return CreateWorkPatternOverrideResponseToJSONTyped(json, false);
  }

  export function CreateWorkPatternOverrideResponseToJSONTyped(value?: CreateWorkPatternOverrideResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': WorkPatternOverrideToJSON(value['data']),
    };
}

